import data from "../../shared/sharedData";

export default {
  name: "Place of Employment Information",
  prefix: "F.e",
  pageInfo: {
    text: `It is important for the employer to define the area of intended employment with as much geographic specificity as possible. This information is used for purposes of reviewing and verifying regulatory compliance with advertising, positive recruitment requirements, and prevailing wage determinations. Note: A prevailing wage determination can only be made for worksites that are identified with enough specificity to determine the applicable Bureau of Labor Statistics (BLS) Area and/or county.`,
    coloring: "grey",
    divider: false,
  },
  sections: [
    {
      fields: [
        {
          code: "F.e.1",
          machine_name: "primaryWorksiteAddr1",
          widget: "text",
          label: "Worksite address 1",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Address 1 must contain at least 2 characters.",
            },
          ],
          maxLength: 60,
          tooltip: `Enter the street address of the worksite location identified in question 1, where the work will be performed. The worksite address must be a physical location and cannot be a P.O. Box.`,
        },
        {
          code: "F.e.2",
          machine_name: "primaryWorksiteAddr2",
          widget: "text",
          label: "Address 2",
          maxLength: 60,
          tooltip: `If additional space is needed for the street address, use this line. If no additional space is needed, enter N/A.`,
        },
        {
          code: "F.e.3",
          machine_name: "primaryWorksiteCity",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: `Enter the city of the worksite location.`,
        },
        {
          code: "F.e.4",
          machine_name: "primaryWorksiteState",
          widget: "select",
          label: "State",
          selection: data.state,
          validate: ["required"],
          state: true,
          tooltip: `Enter the State, District, or Territory of the worksite`,
        },
        {
          code: "F.e.5",
          machine_name: "primaryWorksiteCounty",
          widget: "countyselect",
          label: "County",
          required: true,
          validate: [
            "required",
            {
              required_county: "primaryWorksiteState",
              message: "",
              needsFieldValues: true,
            },
          ],
          disabled: true,
          disableWhenField: "primaryWorksiteState",
          placeholder: "",
          tooltip: `Enter the county or equivalent entity (borough, municipality, parish, independent city, or island name for islands that do not have county equivalents) of the worksite location. When the city and the county or equivalent have the same name, enter the name in both   Since the county or equivalent is used to determine the prevailing wage, the employer must ensure the appropriate county or equivalent is identified based on the worksite location (city and postal code). For work locations in New England states: CT, ME, NH, MA, VT, RI use the city or town where the work will be performed as equivalent to the county.`,
          updateBls: "primaryWorksiteBlsArea",
        },
        {
          code: "F.e.5",
          label: "BLS Area",
          machine_name: "primaryWorksiteBlsArea",
          widget: "text",
          disabled: true,
          hidden: true,
          reviewHidden: true,
        },
        {
          code: "F.e.6",
          machine_name: "primaryWorksitePostalCode",
          widget: "text",
          label: "Postal code",
          validate: ["required", "postalUSA"],
          maxLength: 10,
          tooltip: `Enter the postal (ZIP) code of the worksite location.`,
        },
      ],
    },
    {
      sectionInfo: {
        text: `<b>Important Note:</b> Where work will be performed in any BLS Area other than the BLS Area that includes the worksite address in question 1, the employer must complete Appendix A of the Form ETA-9141 by identifying the additional BLS Area(s) where the services or labor will be performed. In the case of a BLS Area in which there are different county-level prevailing wages, the employer must complete Appendix A when work will be performed in any county other than the county provided as the primary worksite address in question 1. If the employer is unsure whether an additional worksite(s) is in different BLS Area(s) or county(ies) with different wages, the employer must list the additional worksite(s) in Appendix A.`,
        coloring: "grey",
        divider: false,
      },
      fields: [
        {
          isGroup: {
            code: "F.e.7",
            machine_name: "otherWorksiteLocation",
            label:
              "Will work be performed in any Bureau of Labor Statistics Area (Metropolitan or Non-Metropolitan Statistical Areas) other than the Bureau of Labor Statistics Area of the address listed above, or, in the case of Bureau of Labor Statistics areas with multiple county-level prevailing wage rates, in a county other than the county of the address listed above? * (If “Yes,” a completed Appendix A is required)",
            coloring: "none",
            type: "radio",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: 1,
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: 0,
                validate: ["required"],
                clearSchema: ["otherWorksites"],
              },
            ],
            tooltip: `Indicate whether the employer’s job opportunity will be performed in any BLS Area (Metropolitan or Non-Metropolitan Statistical Areas) other than the BLS Area of the address listed in 1-6, or, in the case of BLS Areas with multiple county-level prevailing wage rates, in a county other than the county of the address listed in 1-6 by marking “Yes” or “No.”
            <ul><li>If “Yes” in question 7, the employer must complete and submit Appendix A with this application.  See instructions for Appendix A below.</li></ul>`,
          },
        },
      ],
    },
  ],
};
